import aiGameService from '@/services/aiGame';
import Vue from 'vue';

const state = {
  series: null,
  npcList: {},
};

const getters = {
  getSeriesName(state) {
    return (series) =>
      state.series?.[series]?.title || state.series?.[series] || '';
  },
  getNpcList(state) {
    return (series) => {
      const list = state.npcList?.[series];
      if (!list) return null;
      return list.map((npc) => {
        return {
          ...npc,
          seriesName:
            state.series?.[npc.series]?.title ||
            state.series?.[npc.series] ||
            '',
        };
      });
    };
  },
};

const actions = {
  async getSeries({commit}) {
    const list = await aiGameService.getAiNpcSeries();
    commit('setSeries', list);
    return list;
  },
  async getNpcList({commit}, {series}) {
    const list = await aiGameService.getAiNpcList(series);
    commit('setNpcList', {series, list});
    return list;
  },
};

const mutations = {
  setSeries(state, list) {
    const series = {};
    list.forEach((item) => {
      series[item.series] = item;
    });
    state.series = series;
  },
  setNpcList(state, {series, list}) {
    Vue.set(state.npcList, series, list);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
